import { useField } from 'formik';
import React__default, { useCallback } from 'react';
import { setTestId } from '../../lib/testId.js';
import { setDisabledDataAttribute } from '../inputs/InputCommon.js';
import { SelectInput, NO_VALUE } from '../inputs/SelectInput.js';
import { Stack } from '../layout/Stack.js';
import { hasError } from './Field.js';
import { setErrorDataAttribute, FieldErrorMessage } from './FieldError.js';

const SelectFieldAs = ({ disabled =false , error , name , reserveMessageSpace =true , onFieldChange , children , ...props })=>{
    const [field, meta, helpers] = useField(name);
    const onChange = useCallback((v)=>{
        const updatedValue = v === NO_VALUE ? undefined : v;
        helpers.setValue(updatedValue);
        if (onFieldChange !== undefined) {
            onFieldChange(updatedValue);
        }
    }, [
        helpers,
        onFieldChange
    ]);
    const onFocus = useCallback(()=>{
        helpers.setTouched(true);
    }, [
        helpers
    ]);
    const onBlur = useCallback(()=>{
        helpers.setTouched(true);
    }, [
        helpers
    ]);
    return React__default.createElement(Stack, {
        "data-hpy-web-select-field": true,
        ...setTestId(`SelectField-${props.testId}`),
        ...setDisabledDataAttribute(disabled),
        ...setErrorDataAttribute(hasError(meta) || !!error),
        gap: 0.25
    }, React__default.createElement(SelectInput, {
        ...props,
        ...field,
        value: field.value === undefined || field.value === null ? NO_VALUE : field.value,
        onChange: onChange,
        onFocus: onFocus,
        onBlur: onBlur
    }, children), React__default.createElement(FieldErrorMessage, {
        name: name,
        reserveMessageSpace: reserveMessageSpace,
        error: error
    }));
};
SelectFieldAs.dataId = "data-hpy-web-select-field";
SelectFieldAs.displayName = "SelectField";
const isBase = (props)=>props?.as === undefined;
const isChip = (props)=>props?.as === "chip";
const isButton = (props)=>props?.as === "button";
/**
 * Select Input with Formik Field bindings.
 * Accepts `SelectOptions` as child components. If a 'deselected' option is required, it
 * must be manually added to options with a value of SELECT_OPTION_NO_VALUE.
 *
 * @example
 * <SelectField name="chicken">
 *  <SelectOption label="" value={SELECT_OPTION_NO_VALUE} />
 *  <SelectOption label="Egg" value="egg" />
 *  <SelectOption label="Duck" value="duck" />
 * </SelectField>
 */ const SelectField = ({ children , ...props })=>{
    if (isBase(props)) {
        return React__default.createElement(SelectFieldAs, {
            ...props
        }, children);
    }
    if (isChip(props)) {
        return React__default.createElement(SelectFieldAs, {
            ...props
        }, children);
    }
    if (isButton(props)) {
        return React__default.createElement(SelectFieldAs, {
            ...props
        }, children);
    }
    return null;
};
SelectField.dataId = "data-hpy-web-select-field";
SelectField.displayName = "SelectField";

export { SelectField };
